<script>
    import {PATH_PREFIX} from '../../apiUrls.js';
  import DataTable from '../DataGrid/DataTable.svelte';
  import NoContentCard from './NoContentCard.svelte';
  import Spinner from '../Spinner.svelte';
  import {ApiEndpoints} from './urls';
  import {sgettext} from '../../i18n.js';
  import InfiniteScroll from './InfiniteScroll.svelte';
  import { getColumns, homePageSize } from './columnConstants';
  
  export let branchId;
  export let branch;
  
  import { checked } from './HomePage.svelte';
  import {
    dashBoardWorkCentreId,
  } from './dashBoardStrore.js';
  
  $: url = ApiEndpoints.openIssuesList+`?limit=${homePageSize}&checked=${$checked}&work_centre=${$dashBoardWorkCentreId}`;
  if (branchId) {
    url += `&branch=${branchId}`;
  }
  
  let columns = getColumns('improvements');
  
  function handleOnRowclick(event,row){
      window.open(`${PATH_PREFIX}/sw/common/issues/${row.id}`);
  }
  
  $: data = [];
  $: newBatch = [];
  let count = 0;
  let totalRecords = 0;
  let loading = false;
  let stickyHeader = true;
  let page = 1;

  async function initialFetch() {
		data = [];
    newBatch = [];
    loading = true;
		await fetchData();
    page = 1;
    loading = false;

	}
  async function fetchData() {
       const offset = (page - 1) * homePageSize;
    const response = await fetch(`${url}&offset=${offset}`);
    if(response.ok) {
      const json = await response.json();
      newBatch = await json.results;
      totalRecords = json.count;
      count = count + newBatch.length;
      page = page + 1;
    }
  };

  $: ($checked != null || $dashBoardWorkCentreId >= 0) && initialFetch()
  
  $: !loading && (data = [
    ...data,
    ...newBatch
  ]);
</script>

<h5 style="margin-top:20px;margin-bottom:7px;">
  {sgettext('$$OPEN_IMPROVEMENTS$$')}
</h5>
<div class="card">
  {#if !loading && totalRecords === 0}
    <NoContentCard
      iconName="fa fa-exclamation fa-3x"
      header={sgettext('$$OPEN_ISSUES$$')}
      subHeader={sgettext('$$OPEN_ISSUES_1$$')}
    />
  {:else}
    <div class="card-body p-0 small">
      {#if loading}
        <div>
          <Spinner homePage="true" />
        </div>
      {:else}
        <div class="improvement-table">
          <DataTable
            defaultCellValue="-"
            small={true}
            hover={true}
            onRowClick={handleOnRowclick}
            {columns}
            rows={data}
            {stickyHeader}
          >
            <InfiniteScroll
              slot="infiniteScroll"
              hasMore={newBatch.length}
              threshold={100}
              on:loadMore={async () => {
                if (totalRecords > count) {
                  await fetchData();
                }
              }}
            />
          </DataTable>
        </div>
      {/if}
    </div>
  {/if}
</div>

<style>
  .improvement-table {
    width: 100%;
  }

  .improvement-table :global(tr) {
    display: table;
    width: 100%;
    table-layout: fixed;
  }
  .improvement-table :global(tbody) {
    display: block;
    max-height: 500px;
    overflow-y: scroll;
  }
  .improvement-table :global(::-webkit-scrollbar) {
    -webkit-appearance: none;
    width: 7px;
  }

  .improvement-table :global(::-webkit-scrollbar-track) {
    background: #f2f4f5;
  }

  .improvement-table :global(::-webkit-scrollbar-thumb) {
    background: #888;
  }
</style>
